import { Stack } from '@mui/material';
import { UpcomingToursBase, UpcomingToursProps } from './UpcomingToursBase';
import UpcomingTour from './Tour/UpcomingTour';

export function UpcomingTours(props: Omit<UpcomingToursProps, 'toursList'>) {
    return (
        <UpcomingToursBase
            {...props}
            toursList={(fewLeft, upcomingTours, showRemaining) => (
                <Stack maxWidth={props.bigImages ? '800px' : undefined} width="100%">
                    {upcomingTours.map((tour) => (
                        <UpcomingTour
                            key={tour.id}
                            tour={tour}
                            fewLeft={fewLeft}
                            showRemaining={showRemaining}
                            bigImages={props.bigImages === true}
                        ></UpcomingTour>
                    ))}
                </Stack>
            )}
        />
    );
}
